import httpService from '@/services/httpService'
import _ from 'lodash'
// eslint-disable-next-line no-unused-vars
import RelevancyReport from '../../../features/reports/relevancy/RelevancyReport'

export const types = {
  ADD_RELEVANCY_SESSION: 'rank-zone/ADD_RELEVANCY_SESSION'
}
const emptyData = {
  breakdown: [],
  keywords: [],
  keywordsTotal: []
}
const state = { ...emptyData }

const mutations = {
  [types.ADD_RELEVANCY_SESSION]: function (state, { breakdown, keywords, keywordsTotal }) {
    state.breakdown = breakdown
    state.keywords = keywords
    state.keywordsTotal = keywordsTotal
  }
}

const actions = {
  getRelevancyData: async function ({ commit, dispatch }, { clientId }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    const selectedMsv = msv[clientId] || 1
    const response = await httpService.get(`/reports/relevancy-report/${clientId}`, { params: { msv: selectedMsv } })
    if (!response || !response.data) {
      return
    }
    const breakdown = _.get(response, 'data.breakdown', [])
    const keywords = _.get(response, 'data.keyword_score.scores', [])
    const keywordsTotal = _.get(response, 'data.keyword_score.total', {})
    commit(types.ADD_RELEVANCY_SESSION, { breakdown, keywords, keywordsTotal })
  },
  resetData: function ({ commit }) {
    commit(types.ADD_RELEVANCY_SESSION, emptyData)
  }
}

/**
 * Store for manage {@link RelevancyReport} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
